import type { MetaFunction } from "react-router";
import { ErrorPage } from "~/components/ErrorPage";

export const meta: MetaFunction = () => {
  return [
    { title: "404 - ページが見つかりません | Cytometa Admin" },
    {
      name: "description",
      content: "お探しのページは見つかりませんでした",
    },
  ];
};

export default function CatchAllRoute() {
  return <ErrorPage statusCode={404} />;
}
